// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionSelect_container__1AV3a","selectType":"QuestionSelect_selectType__39h18","actionsWrapper":"QuestionSelect_actionsWrapper__2NYHf"};